import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store'
import 'bootstrap/dist/js/bootstrap.bundle'
import '@/assets/scss/app.scss'
import VueFeather from 'vue-feather';
import VueApexCharts from "vue3-apexcharts";
import ability from './plugins/ability';
// import en from './locales/en.json';
// import pt from './locales/fr.json';
// import fr from './locales/pt.json';
// import es from './locales/es.json';
// import { defaultLocale, localeOptions } from './constants/config';
import Breadcrumbs from './components/bread_crumbs';
import LoadingCard from './components/loading.vue';
import EmptyCard from './components/emptyCard.vue';
import CardHeader from './components/card_header.vue';

import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'

const sweetAlertOptions = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674',
};

// const messages = { en: en, es: es, pt: pt, fr: fr};
// const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

const app = createApp(App)

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", process.env.VUE_APP_API_HOST || ""],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

app.use(router)
app.use(store)
app.use(autoAnimatePlugin)
app.use(VueSweetalert2, sweetAlertOptions)
app.component('multiselect', Multiselect)
app.component(VueFeather.name, VueFeather)
app.component("apexchart", VueApexCharts)
app.component('Breadcrumbs', Breadcrumbs)
app.component('LoadingCard', LoadingCard)
app.component('EmptyCard', EmptyCard)
app.component('CardHeader', CardHeader)
app.mount('#app')
window.Swal =  app.config.globalProperties.$swal;